import { useHydrateReviewAtoms, useReviewOutput } from './hooks';
import type { ReviewOutputDataT } from './types';
type Props = {
  onReviewStateChange: (reviewOutput: ReviewOutputDataT) => void;
  reviewOutput?: ReviewOutputDataT;
};
export const ReviewOutputObserver = ({
  onReviewStateChange,
  reviewOutput
}: Props) => {
  useHydrateReviewAtoms({
    reviewOutput
  });
  useReviewOutput({
    onReviewStateChange
  });
  return null;
};